<script>
import SLSRepresentanteService from '@/services/Cadastros/ApoioVendas/SLSRepresentante.service';
import { mapGetters } from 'vuex';
import { BOverlay } from 'bootstrap-vue';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import SLSCondicaoPagamentoService from '@/services/SistemaDKP/SLSCondicaoPagamento.service';

const slsRepresentanteService = new SLSRepresentanteService();
const slsCondicaoPagamentoService = new SLSCondicaoPagamentoService();
export default {
  name: 'Index',
  components: { BOverlay },
  data() {
    return {
      isLoading: false,
      filtersHeader: {
        representanteid: '',
        representantenome: '',
      },
      currentPage: 1,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        {
          key: 'representanteid', label: 'Código',
        },
        {
          key: 'representantenome', label: 'Nome',
        },
        { key: 'representanteemail', label: 'E-mail' },
        { key: 'representanteativo', label: 'Ativo' },
        { key: 'acoes', label: 'Ações' },
      ],
    };
  },
  watch: {
    currentPage: {
      handler(value) {
        // this.handlePageChange(value);
      },
      immediate: false,
    },
  },
  computed: {
    ...mapGetters('SLSRepresentante', {
      filters: 'filters',
      getRepresentantes: 'representantes',
    }),
    dataMetaRepresentante() {
      const localCount = this.getRepresentantes.length;
      const meta = {
        page: this.filters.perPage * (this.filters.page - 1) + (localCount ? 1 : 0),
        perPage: this.filters.perPage * (this.filters.page - 1) + localCount,
        total: this.filters.total,
      };
      return `Mostrando ${meta.page} de ${meta.perPage} entradas de ${meta.total} entradas`;
    },
  },
  methods: {
    async fetchInitialData() {
      try {
        // Sempre força uma nova busca ao abrir o modal
        this.$store.commit('SLSRepresentante/SET_LOADING', true);
        this.isLoading = true;

        const isCreatePedidos = this.$router.currentRoute && this.$router.currentRoute.name === 'pedidos-vendas-create';

        this.$store.commit('SLSRepresentante/SET_FILTERS', {
          page: 1,
          perPage: 10,
          representanteid: this.filtersHeader.representanteid || null,
          representantenome: this.filtersHeader.representantenome || null,
        });

        await slsRepresentanteService.listarRepresentanteInfoPedido();

        // Em telas de criação de pedidos, a lógica acima já cobre o cenário
        if (isCreatePedidos) {
          // Mantém o page em 1 para garantir início consistente
          this.currentPage = 1;
        }
      } catch (error) {
        console.error('Error fetching initial data:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: `${error.message}`,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.$store.commit('SLSRepresentante/SET_LOADING', false);
        this.isLoading = false;
      }
    },
    async info(item) {
      try {
        this.isLoading = true;
        this.$store.commit('InfoPedido/SET_LOADING_REPRESENTANTE', true);

        this.$store.commit('InfoPedido/SET_REPRESENTANTE_FORM', item);
        this.$store.commit('SLSRepresentante/SET_SELECTED_REPRESENTANTE', item);
        this.$store.commit('intensPedido/SET_IFO_REPRESENTANTE', {
          representanteid: item.representanteid,
          representantenome: item.representantenome,
        });

        // Limpar os dados do cliente
        await this.$store.dispatch('InfoPedido/resetarClienteInfoPedido');
        this.$store.commit('intensPedido/SET_CAPA_PEDIDO', {
          ...this.$store.getters['intensPedido/getFormData'].dataCapaPedido,
          clienteiderp: '',
          cliente_nome: '',
          clientenomeabreviado: '',
          clienteisentoie: '',
          condicaopagamentoid: '',
          condicaopagamentodescricao: '',
          tabelaprecoid: '',
          tabelapreco_descricao: '',
          naturezaoperacaoid: '',
          naturezaoperacaodescricao: '',
          canalvendaid: '',
          canal_venda_descricao: '',
          estabelecimentoid: '',
          estabelecimentorazaosocial: '',
        });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Processando',
            text: 'Carregando informações do representante e seus clientes...',
            icon: 'LoaderIcon',
            variant: 'info',
          },
        });

        // Salvamento no localStorage
        // if (this.$store.getters['auth/IS_LOGGED_IN']) {
        //   const formData = this.$store.getters["InfoPedido/GET_FORM_INFO_PEDIDO"];
        //   const userData = JSON.parse(localStorage.getItem('userData'));
        //   const userId = userData?.id || 'default';
        //   localStorage.setItem(`infoPedidoForm_${userId}`, JSON.stringify(formData));
        // }

        this.$bvModal.hide('modal-buscar-representante');

        this.$root.$emit('representante:changed', item.representanteid);
      } catch (error) {
        console.error('Erro ao selecionar representante:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Ocorreu um erro ao selecionar o representante',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.isLoading = false;
        this.$store.commit('InfoPedido/SET_LOADING_REPRESENTANTE', false);
      }
    },
    resetInfoModal() {
      this.infoModal.title = '';
      this.infoModal.content = '';
    },
    async handlePageChange(value) {
      if (this.filters.page !== value) {
        this.$store.commit('SLSRepresentante/SET_FILTERS', {
          ...this.$store.getters['SLSRepresentante/filters'],
          page: value,
        });
        await slsRepresentanteService.listarRepresentanteInfoPedido();
      }
    },
    async handleFiltersHeader() {
      try {
        this.$store.commit('SLSRepresentante/SET_FILTERS', {
          ...this.$store.getters['SLSRepresentante/filters'],
          page: 1,
          representanteid: this.filtersHeader.representanteid || null,
          representantenome: this.filtersHeader.representantenome || null,
        });

        await slsRepresentanteService.listarRepresentanteInfoPedido();
      } catch (error) {
        console.error('Error applying filters:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: `${error.message}`,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
      }
    },
    async resertFilters() {
      this.filtersHeader = {
        representanteid: '',
        representantenome: '',
      };
      this.$store.commit('SLSRepresentante/SET_FILTERS_REPRESENTANTE_ID', null);
      this.$store.commit('SLSRepresentante/SET_FILTERS_REPRESENTANTE_NOME', null);
      await slsRepresentanteService.listarRepresentanteInfoPedido();
    },
  },
};
</script>

<template>
  <b-modal id="modal-buscar-representante" size="xl" ref="modalBuscarRepresentante" title="Buscar Representante" ok-only
    @show="fetchInitialData"
    ok-title="FECHAR">
    <b-overlay variant="white" :show="$store.getters['SLSRepresentante/loading']" spinner-variant="primary" blur="0"
      opacity=".75" rounded="sm">
      <b-row>
        <b-col cols="12" md="5">
          <b-form-group label="Código:" label-for="disabledInput">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input placeholder="Código" v-model="filtersHeader.representanteid" />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="5">
          <b-form-group label="Nome:" label-for="disabledInput">
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input placeholder="Nome" v-model="filtersHeader.representantenome" />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="2" align-self="center">
          <b-row>
            <b-col cols="12" md="6">
              <b-button variant="success" @click="handleFiltersHeader">
                Filtrar
              </b-button>
            </b-col>
            <b-col cols="12" md="6">
              <b-button variant="danger" @click="resertFilters">
                Limpar
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col cols="12">
          <b-table striped hover responsive :current-page="currentPage" :items="getRepresentantes" :fields="fields"
            show-empty empty-text="Nenhum representante encontrado">
            <template #cell(acoes)="data">
              <b-button size="sm" variant="primary" @click="info(data.item, data.index, $event.target)"
                :disabled="isProcessingSelection">
                <b-spinner small v-if="isProcessingSelection"></b-spinner>
                <span>Selecionar</span>
              </b-button>
            </template>

            <template #cell(representanteativo)="data">
              <b-badge :variant="data.value === 1 ? 'success' : 'danger'">
                {{ data.value === 1 ? 'Ativo' : 'Inativo' }}
              </b-badge>
            </template>
          </b-table>
        </b-col>

        <b-col cols="12">
          <div class="mx-2 mb-2">
            <b-row>
              <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
                <span class="text-muted">{{ dataMetaRepresentante }}</span>
              </b-col>
              <!-- Pagination -->
              <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
                <b-pagination v-model="currentPage" :total-rows="filters.total" :per-page="filters.perPage"
                  @change="handlePageChange($event)" first-number last-number align="center" class="my-0" />
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-overlay>
  </b-modal>
</template>

<style scoped lang="scss"></style>
